var _circle, _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryNovaPoshta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 15.6667,
    cy: 15.0002,
    r: 12.6316,
    fill: "#169CE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8277 10.3369V16.5264H13.6783V13.8737H10.4774V16.5264H9.32794V10.3369H10.4774V12.8923H13.6783V10.3369H14.8277ZM22.0461 10.3369V16.5264H20.9143V11.3095H17.7046V16.5264H16.5728V10.3369H22.0461Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.0354,
    y: 2.36816,
    width: 25.2632,
    height: 25.2632,
    rx: 3.78947,
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7901 10.993C21.8503 10.974 21.9295 11.0119 22.0087 11.1161C22.0087 11.1161 22.0087 11.1161 25.5882 14.6071C25.7972 14.8155 25.7972 15.1311 25.5882 15.2858C25.5882 15.2858 25.5882 15.2858 22.0087 18.8305C21.9295 18.9347 21.8503 18.9599 21.7901 18.9284C21.7299 18.8968 21.6919 18.8053 21.6919 18.6727V11.2202C21.6919 11.0908 21.7299 11.0119 21.7901 10.993Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6664 5.17529H15.9198L16.1638 5.2763C16.1638 5.2763 16.1638 5.2763 19.8478 8.9252C20.0062 9.13353 19.9523 9.29135 19.6894 9.29135C19.6894 9.29135 19.6894 9.29135 18.1626 9.29135C17.8997 9.29135 17.6906 9.49968 17.6906 9.76167C17.6906 9.76167 17.6906 9.76167 17.6906 12.4699C17.6906 12.7319 17.4784 12.9402 17.1616 12.9402C17.1616 12.9402 17.1616 12.9402 14.4785 12.9402C14.2156 12.9402 14.0034 12.7319 14.0034 12.4699C14.0034 12.4699 14.0034 12.4699 14.0034 9.76167C14.0034 9.49968 13.7943 9.29135 13.5282 9.29135H11.8969C11.6339 9.29135 11.5801 9.13353 11.7385 8.9252C11.7385 8.9252 11.7385 8.9252 15.4257 5.2763L15.6664 5.17529Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89512 10.9141C9.96164 10.9456 10.0028 11.0372 10.0028 11.1698V18.7769C10.0028 18.9095 9.96164 18.9884 9.89512 19.0136C9.83176 19.0389 9.7399 19.0136 9.6322 18.9347C9.6322 18.9347 9.6322 18.9347 5.99884 15.2858C5.78977 15.1311 5.78977 14.8155 5.99884 14.6072C5.99884 14.6072 5.99884 14.6072 9.6322 11.0119C9.7399 10.9078 9.83176 10.8825 9.89512 10.9141Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4788 16.9019C14.4788 16.9019 14.4788 16.9019 17.1618 16.9019C17.4786 16.9019 17.6908 17.1102 17.6908 17.3722C17.6908 17.3722 17.6908 17.3722 17.6908 20.2383C17.6908 20.5508 17.8999 20.7591 18.1628 20.7591H19.5851C19.848 20.7591 19.9526 20.9137 19.7435 21.0716C19.7435 21.0716 19.7435 21.0716 16.164 24.6668C16.0563 24.771 15.9264 24.8246 15.7934 24.8246C15.6635 24.8246 15.5305 24.771 15.4259 24.6668C15.4259 24.6668 15.4259 24.6668 11.8464 21.0716C11.6342 20.9137 11.7387 20.7591 12.0016 20.7591C12.0016 20.7591 12.0016 20.7591 13.5285 20.7591C13.7946 20.7591 14.0036 20.5508 14.0036 20.2383C14.0036 20.2383 14.0036 20.2383 14.0036 17.3722C14.0036 17.1102 14.2159 16.9019 14.4788 16.9019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryNovaPoshta);
export default __webpack_public_path__ + "static/media/delivery_nova_poshta.e1daa5e5184ad2d45da7f8e07979c8c6.svg";
export { ForwardRef as ReactComponent };